import { render, staticRenderFns } from "./seeDiscounts.vue?vue&type=template&id=15437b2a&scoped=true"
import script from "./seeDiscounts.vue?vue&type=script&lang=js"
export * from "./seeDiscounts.vue?vue&type=script&lang=js"
import style0 from "./seeDiscounts.vue?vue&type=style&index=0&id=15437b2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15437b2a",
  null
  
)

export default component.exports